<app-header #header></app-header>
<div class="main-wrapper">
  <router-outlet></router-outlet>
</div>
<div class="fb-customerchat" page_id="110836661275358">
</div>
<app-footer></app-footer>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" color="#fff" type="ball-clip-rotate-multiple"></ngx-spinner>